import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import moduleUser from '@/store/moduleUser';
import moduleMain from '@/store/moduleMain';

const store = createStore({
  modules: {
    user: moduleUser,
    main: moduleMain
  },
  plugins: [
    createPersistedState({
      paths: ['user']
    })
  ]
});

export default store;
